import React from "react";
import { useRouter } from "@tanstack/react-location";
import {
  LDProvider,
  useFlags,
  useLDClient,
  basicLogger,
} from "launchdarkly-react-client-sdk";
import { useStateManagerContext } from "../stateManager";

interface FeatureFlagProviderProps {
  children: React.ReactNode;
}

const FeatureFlagProvider = ({ children }: FeatureFlagProviderProps) => {
  const { sdkState } = useStateManagerContext();
  const router = useRouter();

  return (
    <LDProvider
      clientSideID={import.meta.env.VITE_LAUNCH_DARKLY_KEY}
      context={{
        kind: "organization",
        // Switching to clientId instead of sending the complete apiKey
        key: sdkState.clientId,
        custom: {
          locale: sdkState.globalOptions?.locale || "en",
          /**
           * Set the 'sdk' value to the current SDK, which can be found in the
           * location pathname.
           */
          sdk: router.state.location.pathname.split("/")[3],
        },
      }}
      reactOptions={{
        sendEventsOnFlagRead: true,
      }}
      options={{
        streaming: true,
        logger: basicLogger({ level: "none" }),
      }}
    >
      {children}
    </LDProvider>
  );
};

export { FeatureFlagProvider, useFlags, useLDClient };
